import { $ } from '@zimpa/dom';

const CONTAINER_SELECTOR = '.js-newsletter-popup';
const POPUP_TRIGGER = '.js-popup-trigger';
const POPUP_CLOSE = '.js-popup-close'


export function newsletterPopup(): void {
    const container = $(CONTAINER_SELECTOR);
    const trigger = $(POPUP_TRIGGER);
    const close = $(POPUP_CLOSE);
    const SCROLL_BLOCK_CLASS = 'scroll-block';
    if (
        container === undefined ||
        trigger === undefined ||
        close === undefined
    ) {
        return;
    }
    if (trigger && container && close) {
        trigger.addEventListener("click", function (event) {
            event.preventDefault();
            container.classList.add("show");
                document.body.classList.add(SCROLL_BLOCK_CLASS);
        });

        close.addEventListener("click", function () {
            container.classList.remove("show");
            document.body.classList.remove(SCROLL_BLOCK_CLASS);
        });


        container.addEventListener("click", function (event) {
            if (event.target === container) {
                container.classList.remove("show");
            }
        });
    }
}
